import React from "react";
import '../../css/components/controls/HrnbForm.css'

export default function HrnbForm({
                                     onSubmit,
                                     children,
                                     className = "",
                                     style = {},
                                     disabled = false,
                                     title, // новый проп
                                     ...props
                                 }) {
    const handleSubmit = (e) => {
        e.preventDefault();
        if (disabled) return;
        if (onSubmit) onSubmit(e);
    };

    return (
        <form
            className={`hrnb-form ${className} ${disabled ? "hrnb-form--disabled" : ""}`}
            style={style}
            onSubmit={handleSubmit}
            autoComplete="off"
            {...props}
        >
            {title && (
                <div className="hrnb-form__title" style={{
                    fontWeight: 600,
                    fontSize: 22,
                    marginBottom: 20,
                    textAlign: "center"
                }}>
                    {title}
                </div>
            )}
            {children}
        </form>
    );
}

